export default {
  documentTitle:
    'Portefeuille matériel - Votre allié clé pour sécuriser les actifs crypto | KeyPal',
  product: 'Produit',
  learn: 'Apprendre',
  support: 'Support',
  others: 'Autres',
  language: 'Langue',
  forBusiness: 'Pour les entreprises',
  apps: 'Applications',
  secretBox: 'Secret Box',
  learnMore: 'En savoir plus', 
  goShoppingCart: 'Aller à la boutique', 
  contactUs: 'Contactez-nous:', 
  tutorials: 'Tutoriels', 
  mobileWallet: 'Portefeuille mobile', 
  extensionWallet: 'Portefeuille extension', 
  cases: 'Études de cas:', 
  cooperationSolution: 'Solutions de partenariat', 
  information: 'Information', 
  security: 'Sécurité', 
  darkMode: 'Mode sombre',
  KeyPal_2_firmware: 'Micrologiciel KeyPal 2', 
  KeyPal_Plus_firmware: 'Firmware de KeyPal Plus', 
  more: 'et plus encore...',
  comingSoon: 'Bientôt disponible',
}
